var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1797,
    height: 1492,
    viewBox: "0 0 1797 1492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_241_147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1523.63 755.616C1523.63 893.406 1403.97 1002.15 1284.82 1090.65C1171.69 1174.68 1063.51 1242 894.202 1242C742.924 1242 632.004 1209.76 523.455 1141.03C382.567 1051.84 264.771 907.34 264.771 755.616C264.771 617.826 205.443 409.409 324.589 320.909C437.718 236.879 724.891 269.231 894.202 269.231C1063.51 269.231 1366.48 211.675 1479.61 295.706C1598.76 384.205 1523.63 617.826 1523.63 755.616Z",
    fill: "url(#paint0_radial_241_147)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_241_147",
    x: 0,
    y: 0,
    width: 1797,
    height: 1492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_241_147"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_241_147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(360.276 357.675) rotate(16.235) scale(1178.37 2316.82)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9B43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowGlow);
export default __webpack_public_path__ + "static/media/yellowGlow.cb25b4e16fdca9bfe0009ba5786b47c1.svg";
export { ForwardRef as ReactComponent };